import useApiRequest from "@/lib/hooks/use-request";
import { InvoiceListResponseDto } from "@/lib/interfaces/invoices";
import { Paginated, Pagination } from "@/lib/interfaces/utils";
import DataFetchParent from "@/ui-components/ui/data-fetch";
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";
import InvoicesDataTable from "./invoices-data-table";

export const InvoicesFetcher = ({
  searchQuery,
  setReload,
  reload,
}: {
  searchQuery: string;
  setReload: Dispatch<SetStateAction<boolean>>;
  reload: boolean;
}) => {
  const [items, setItems] = useState<InvoiceListResponseDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { apiRequest } = useApiRequest();
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: searchQuery.split("page=")[1] ? parseInt(searchQuery.split("page=")[1].split("&")[0]) - 1 : 0,
    pageSize: 10,
  });

  const [pageCount, setPageCount] = useState<number>(0);

  const getItemsPaginated = useCallback(async () => {
    setIsLoading(true);
    let url = `invoices?limit=${pagination.pageSize}&page=${pagination.pageIndex + 1}`;
    const response = await apiRequest<Paginated<InvoiceListResponseDto>>(url, "GET");
    setIsLoading(false);
    if (response.data) {
      setItems(response.data.docs);
      setPageCount(response.data.pageCount);
    }
  }, [apiRequest, pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    getItemsPaginated();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, getItemsPaginated, searchQuery, reload]);

  return (
    <DataFetchParent
      data={items}
      isLoading={isLoading}
      renderElement={(response: InvoiceListResponseDto[]) => (
        <div className="w-full p-4">
          <InvoicesDataTable
            data={response}
            isLoading={isLoading}
            pageCount={pageCount}
            pagination={pagination}
            setPagination={setPagination}
            setReload={setReload}
          />
        </div>
      )}
    />
  );
};

export default InvoicesFetcher;
